<template>
  <v-row>
    <v-col cols = "12">
      <v-data-table
    :headers="dessertHeaders"
    :items="desserts"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    item-key="name"
    show-expand
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-switch
          v-model="singleExpand"
          label="Expandir apenas um"
          class="mt-2"
        ></v-switch>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">

          <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            
          </th>
          <th class="text-left">
            Pagos
          </th>
          <th class="text-left">
            Valor
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="s in item.detalhes"
          :key="s"
        >
          <td>{{ s.name }}</td>
          <td>{{ s.quantity }}</td>
          <td>R$ {{ s.value.toFixed(2).replace('.', ',') }}</td>
        </tr>
      </tbody>      
    </template>
  </v-simple-table>
      </td>
      
    </template>
    
  </v-data-table>

    </v-col>
    <v-col cols="12">
      <v-simple-table>
        <thead style="background-color: #3F51B5;">
          <th></th>
          <th class="text-center">Contactados</th>
          <th class="text-center">Pagamentos</th>
          <th class="text-center">Total</th>
          <th class="text-center">Tempo de Abordagem</th>
          <th class="text-center">Tempo de conversão</th>
        </thead>

        <tbody>
          <tr>
            <td>Boletos</td>
            <td class="text-center">{{ report.billets.total.quantity }}</td>
            <td class="text-center">
              {{ report.billets.finished.quantity }} 
              ({{  
                (report.billets.finished.quantity > 0)
                ? ((report.billets.finished.quantity/report.billets.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.billets.finished.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.billets.total.aproach_avg_time)}}
            </td>
            <td class="text-center">
              -
            </td>
          </tr>
          <tr>
            <td>Pix</td>
            <td class="text-center">{{ report.pix.total.quantity }}</td>
            <td class="text-center">
              {{ report.pix.finished.quantity }} 
              ({{  
                (report.pix.finished.quantity > 0)
                ? ((report.pix.finished.quantity/report.pix.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.pix.finished.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.pix.total.aproach_avg_time)}}
            </td>
            <td class="text-center">
              -
            </td>
          </tr>
          <tr v-if="report.addi.total.quantity">
            <td>Addi</td>
            <td class="text-center">{{ report.addi.total.quantity }}</td>
            <td class="text-center">
              {{ report.addi.finished.quantity }} 
              ({{  
                (report.addi.finished.quantity > 0)
                ? ((report.addi.finished.quantity/report.addi.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.addi.finished.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.addi.total.aproach_avg_time)}}
            </td>
            <td class="text-center">
              -
            </td>
          </tr>
          <tr>
            <td>Boletos Finalizados no Cartão</td>
            <td class="text-center">
              -
              <!-- {{ report.billets_card_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.billets_card_finished.total.quantity}}
              ({{  
                (report.billets_card_finished.total.quantity > 0)
                ? ((report.billets_card_finished.total.quantity/report.billets.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.billets_card_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.billets_card_finished.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr>
            <td>Boletos Finalizados no Pix</td>
            <td class="text-center">
              -
              <!-- {{ report.billets_pix_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.billets_pix_finished.total.quantity}}
              ({{  
                (report.billets_pix_finished.total.quantity > 0)
                ? ((report.billets_pix_finished.total.quantity/report.billets.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.billets_pix_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.billets_pix_finished.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr>
            <td>Pix Finalizados no Boleto</td>
            <td class="text-center">
              -
              <!-- {{ report.pix_billet_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.pix_billet_finished.total.quantity}}
              ({{  
                (report.pix_billet_finished.total.quantity > 0)
                ? ((report.pix_billet_finished.total.quantity/report.pix.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.pix_billet_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.pix_billet_finished.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr>
            <td>Pix Finalizados no Cartão</td>
            <td class="text-center">
              -
              <!-- {{ report.pix_billet_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.pix_card_finished.total.quantity}}
              ({{  
                (report.pix_card_finished.total.quantity > 0)
                ? ((report.pix_card_finished.total.quantity/report.pix.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.pix_card_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.pix_card_finished.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr v-if="report.addi.total.quantity">
            <td>Addi Finalizados no Boleto</td>
            <td class="text-center">
              -
              <!-- {{ report.pix_billet_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.addi_billet_finished.total.quantity}}
              ({{  
                (report.addi_billet_finished.total.quantity > 0)
                ? ((report.addi_billet_finished.total.quantity/report.addi.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.addi_billet_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.addi_billet_finished.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr v-if="report.addi.total.quantity">
            <td>Addi Finalizados no cartão</td>
            <td class="text-center">
              -
              <!-- {{ report.pix_billet_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.addi_paid_credit_card.total.quantity}}
              ({{  
                (report.addi_paid_credit_card.total.quantity > 0)
                ? ((report.addi_paid_credit_card.total.quantity/report.addi.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.addi_paid_credit_card.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.addi_paid_credit_card.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr v-if="report.addi.total.quantity">
            <td>Addi Finalizados no pix</td>
            <td class="text-center">
              -
              <!-- {{ report.pix_billet_finished.total.quantity }} -->
            </td>
            <td class="text-center">
              {{report.addi_pix_finished.total.quantity}}
              ({{  
                (report.addi_pix_finished.total.quantity > 0)
                ? ((report.addi_pix_finished.total.quantity/report.addi.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.addi_pix_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{secondsToDhms(report.addi_pix_finished.total.conversion_avg_time)}}
            </td>
          </tr>
          <!-- <tr>
            <td>Abandonos Finalizados no Cartão</td>
            <td class="text-center">
              -
            </td>
            <td class="text-center">
              {{ report.abandoned_carts_card_finished.total.quantity }}
              ({{  
                (report.abandoned_carts_card_finished.total.quantity > 0)
                ? ((report.abandoned_carts_card_finished.total.quantity/report.abandoned_carts.total.quantity)*100) 
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.abandoned_carts_card_finished.total.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              -

            </td>
            <td class="text-center">
              {{report.abandoned_carts_card_finished.total.conversion_avg_time}}
            </td>
          </tr> -->
          <tr>
            <td>Cartões Recusados</td>
            <td class="text-center">{{ report.refused_cards.total.quantity }}</td>
            <td class="text-center">
              {{ report.refused_cards.finished.quantity }}
              ({{  
                (report.refused_cards.finished.quantity > 0)
                ? ((report.refused_cards.finished.quantity/report.refused_cards.total.quantity)*100)
                  .toFixed(2)
                  .replace('.', ',')
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.refused_cards.finished.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.refused_cards.total.aproach_avg_time)}}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.refused_cards.total.conversion_avg_time)}}
            </td>
          </tr>
          <tr>
            <td>Abandonos de Carrinho</td>
            <td class="text-center">{{ report.abandoned_carts.total.quantity }}</td>
            <td class="text-center">
              {{ report.abandoned_carts.finished.quantity}}
              ({{  
                (report.abandoned_carts.finished.quantity > 0)
                ? ((report.abandoned_carts.finished.quantity/report.abandoned_carts.total.quantity)*100)
                .toFixed(2)
                .replace('.', ',') 
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.abandoned_carts.finished.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.abandoned_carts.total.aproach_avg_time)}}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.abandoned_carts.finished.conversion_avg_time)}}
            </td>
          </tr>
        </tbody>

        <thead>
          <th><strong>Total</strong></th>
          <th class="text-center">
            {{ contactedTotal() }}
          </th>
          <th class="text-center">
            {{ convertedTotal() }}
            ({{  
              (contactedTotal() > 0)
              ? (convertedTotal()/contactedTotal()*100)
                .toFixed(2)
                .replace('.', ',')
              : "0,00"
            }}%)
          </th>
          <th class="text-center">
            R$ {{ amountTotal().toFixed(2).replace('.', ',') }}
          </th>
          <th class="text-center"></th>
          <th class="text-center"></th>
        </thead>
        <!-- <tbody>
          <tr>
            <td>Abandonos</td>
            <td class="text-center">{{ report.abandoned_carts.total.quantity }}</td>
            <td class="text-center">
              {{ report.abandoned_carts.finished.quantity}}
              ({{  
                (report.abandoned_carts.finished.quantity > 0)
                ? ((report.abandoned_carts.finished.quantity/report.abandoned_carts.total.quantity)*100)
                .toFixed(2)
                .replace('.', ',') 
                : "0,00"
              }}%)
            </td>
            <td class="text-center">
              R$ {{ report.abandoned_carts.finished.amount.toFixed(2).replace('.', ',') }}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.abandoned_carts.total.aproach_avg_time)}}
            </td>
            <td class="text-center">
              {{secondsToDhms(report.abandoned_carts.finished.conversion_avg_time)}}
            </td>
          </tr>
        </tbody> -->
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    methods: {
      contactedTotal() {
        return this.report.billets.total.quantity
              + this.report.abandoned_carts.total.quantity
              + this.report.refused_cards.total.quantity
              + this.report.pix.total.quantity
              + this.report.addi.total.quantity
      },
      convertedTotal() {
        return this.report.billets.finished.quantity 
              + this.report.billets_card_finished.total.quantity
              + this.report.billets_pix_finished.total.quantity
              + this.report.abandoned_carts.finished.quantity
              + this.report.refused_cards.finished.quantity
              + this.report.pix.finished.quantity
              + this.report.pix_billet_finished.total.quantity
              + this.report.pix_card_finished.total.quantity
              + this.report.addi.finished.quantity
              + this.report.addi_billet_finished.total.quantity
              + this.report.addi_paid_credit_card.total.quantity
              + this.report.addi_pix_finished.total.quantity;
      },
      amountTotal() {
        return this.report.billets.finished.amount
              + this.report.billets_card_finished.total.amount
              + this.report.billets_pix_finished.total.amount
              + this.report.abandoned_carts.total.amount
              + this.report.refused_cards.finished.amount
              + this.report.pix.finished.amount
              + this.report.pix_billet_finished.total.amount
              + this.report.pix_card_finished.total.amount
              + this.report.addi.finished.amount
              + this.report.addi_billet_finished.total.amount
              + this.report.addi_paid_credit_card.total.amount
              + this.report.addi_pix_finished.total.amount;
      },
      secondsToDhms(seconds) {
        seconds = Number(seconds);

        if(!seconds > 0)
          return 0;

        const d = Math.floor(seconds / (3600*24));
        const h = Math.floor(seconds % (3600*24) / 3600);
        const m = Math.floor(seconds % 3600 / 60);
        const s = Math.floor(seconds % 60);

        const dDisplay = d > 0 ? d + (d == 1 ? " dia, " : " dias, ") : "";
        const hDisplay = h > 0 ? h + (h == 1 ? " hora, " : " horas, ") : "";
        const mDisplay = m > 0 ? m + (m == 1 ? " minuto, " : " minutos, ") : "";
        const sDisplay = s > 0 ? s + (s == 1 ? " segundo" : " segundos") : "";

        return (dDisplay + hDisplay + mDisplay + sDisplay).replace(/,\s*$/, "");
      },
      ConvertToReal(value){
        return value.toFixed(2).replace('.', ',');
      },
      getBillets(){
        const total_contactados = this.$store.state.user_store_report.billets.total.quantity - this.$store.state.user_store_report.pix_billet_finished.total.quantity - this.$store.state.user_store_report.refused_cards_billet_finished.total.quantity - this.$store.state.user_store_report.abandoned_carts_billet_finished.total.quantity - this.$store.state.user_store_report.addi_billet_finished.total.quantity;
        const total_pagos = (this.$store.state.user_store_report.billets.finished.quantity - this.$store.state.user_store_report.pix_billet_finished.total.quantity - this.$store.state.user_store_report.refused_cards_billet_finished.total.quantity - this.$store.state.user_store_report.abandoned_carts_billet_finished.total.quantity - this.$store.state.user_store_report.addi_billet_finished.total.quantity) + this.$store.state.user_store_report.billets_card_finished.total.quantity + this.$store.state.user_store_report.billets_pix_finished.total.quantity;
        const total_pagos_valor = (this.$store.state.user_store_report.billets.finished.amount - this.$store.state.user_store_report.pix_billet_finished.total.amount - this.$store.state.user_store_report.refused_cards_billet_finished.total.amount - this.$store.state.user_store_report.abandoned_carts_billet_finished.total.amount - this.$store.state.user_store_report.addi_billet_finished.total.amount) + this.$store.state.user_store_report.billets_card_finished.total.amount + this.$store.state.user_store_report.billets_pix_finished.total.amount;
        
        return {"total_contactados": total_contactados, "total_pagos": total_pagos, "total_pagos_valor": total_pagos_valor};
      },
      getPix(){
        const total_contactados =  this.$store.state.user_store_report.pix.total.quantity - this.$store.state.user_store_report.billets_pix_finished.total.quantity - this.$store.state.user_store_report.refused_cards_pix_finished.total.quantity - this.$store.state.user_store_report.abandoned_carts_pix_finished.total.quantity;
        const total_pagos = (this.$store.state.user_store_report.pix.finished.quantity - this.$store.state.user_store_report.billets_pix_finished.total.quantity - this.$store.state.user_store_report.refused_cards_pix_finished.total.quantity - this.$store.state.user_store_report.abandoned_carts_pix_finished.total.quantity) + this.$store.state.user_store_report.pix_card_finished.total.quantity + this.$store.state.user_store_report.pix_billet_finished.total.quantity;
        const total_pagos_valor = (this.$store.state.user_store_report.pix.finished.amount - this.$store.state.user_store_report.billets_pix_finished.total.amount - this.$store.state.user_store_report.refused_cards_pix_finished.total.amount - this.$store.state.user_store_report.abandoned_carts_pix_finished.total.amount) + this.$store.state.user_store_report.pix_card_finished.total.amount + this.$store.state.user_store_report.pix_billet_finished.total.amount;
        return {"total_contactados": total_contactados, "total_pagos": total_pagos, "total_pagos_valor": total_pagos_valor};
      },
      getRefusedCard(){
        const total_contactados = this.$store.state.user_store_report.refused_cards.total.quantity;
        const total_pagos =  this.$store.state.user_store_report.refused_cards.finished.quantity;
        const total_pagos_valor = this.$store.state.user_store_report.refused_cards.finished.amount;
        
        return {"total_contactados": total_contactados, "total_pagos": total_pagos, "total_pagos_valor": total_pagos_valor};
      },
      getAbandonedCart(){
        const total_contactados = this.$store.state.user_store_report.abandoned_carts.total.quantity;
        const total_pagos = this.$store.state.user_store_report.abandoned_carts.finished.quantity;
        const total_pagos_valor = this.$store.state.user_store_report.abandoned_carts.finished.amount;
        
        return {"total_contactados": total_contactados, "total_pagos": total_pagos, "total_pagos_valor": total_pagos_valor};
      },
      getPorcent(total_pago, total){
        return ((total_pago/total)*100).toFixed(2).replace('.', ',');
              
      },
    },
    data() {
      return {
        boletos: null,
        report: this.$store.state.user_store_report,
        expanded: [],
        singleExpand: false,
        dessertHeaders: 
        [
          {
            text: ' ',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Contactados', value: 'Contactados' },
          { text: 'Pagos', value: 'Pagos' },
          { text: '%', value: 'Pagos_porcentagem' },
          { text: 'Total', value: 'Total' },
          { text: 'Tempo de Abordagem', value: 'TempoAbordagem' },
          { text: 'Tempo de Conversão', value: 'TempoConversao' },
        ],
        desserts: [
          {
            name: 'Boletos',
            Contactados: this.getBillets().total_contactados,
            Pagos: this.getBillets().total_pagos,
            Pagos_porcentagem: this.getPorcent(this.getBillets().total_pagos, this.getBillets().total_contactados) + "%",
            Total: "R$ " + this.ConvertToReal(this.getBillets().total_pagos_valor),
            TempoAbordagem: this.secondsToDhms(this.$store.state.user_store_report.billets.total.aproach_avg_time),
            TempoConversao: this.secondsToDhms(this.$store.state.user_store_report.billets.total.conversion_avg_time),
            detalhes:
            [
              {
                name: 'Boletos finalizados no Pix',
                quantity: this.$store.state.user_store_report.billets_pix_finished.total.quantity,
                value:this.$store.state.user_store_report.billets_pix_finished.total.amount
              },
              {
                name: 'Boletos finalizados no Cartão',
                quantity: this.$store.state.user_store_report.billets_card_finished.total.quantity,
                value:this.$store.state.user_store_report.billets_card_finished.total.amount
              }
            ],
          },
          {
            name: 'Pix',
            Contactados: this.getPix().total_contactados,
            Pagos: this.getPix().total_pagos,
            Pagos_porcentagem: this.getPorcent(this.getPix().total_pagos, this.getPix().total_contactados) + "%",
            Total: "R$ " + this.ConvertToReal(this.getPix().total_pagos_valor),
            TempoAbordagem: this.secondsToDhms(this.$store.state.user_store_report.pix.total.aproach_avg_time),
            TempoConversao: this.secondsToDhms(this.$store.state.user_store_report.pix.total.conversion_avg_time),
            detalhes:
            [
              {
                name: 'Pix finalizados no Boleto',
                quantity: this.$store.state.user_store_report.pix_billet_finished.total.quantity,
                value:this.$store.state.user_store_report.pix_billet_finished.total.amount
              },
              {
                name: 'Pix finalizados no Cartão',
                quantity: this.$store.state.user_store_report.pix_card_finished.total.quantity,
                value:this.$store.state.user_store_report.pix_card_finished.total.amount
              }
            ],
          },
          {
            name: 'Cartões Recusados',
            Contactados: this.$store.state.user_store_report.refused_cards.total.quantity,
            Pagos: this.$store.state.user_store_report.refused_cards.finished.quantity,
            Pagos_porcentagem: this.getPorcent(this.getRefusedCard().total_pagos, this.getRefusedCard().total_contactados) + "%",
            Total:"R$ " + this.ConvertToReal(this.getRefusedCard().total_pagos_valor),
            TempoAbordagem: this.secondsToDhms(this.$store.state.user_store_report.refused_cards.total.aproach_avg_time),
            TempoConversao: this.secondsToDhms(this.$store.state.user_store_report.refused_cards.total.conversion_avg_time),
            detalhes:[
              {
                name: 'Finalizados no Boleto',
                quantity: this.$store.state.user_store_report.refused_cards_billet_finished.total.quantity,
                value:this.$store.state.user_store_report.refused_cards_billet_finished.total.amount
              },
              {
                name: 'Finalizados no Pix',
                quantity: this.$store.state.user_store_report.refused_cards_pix_finished.total.quantity,
                value:this.$store.state.user_store_report.refused_cards_pix_finished.total.amount
              },
              {
                name: 'Finalizados no Cartão',
                quantity: this.$store.state.user_store_report.refused_cards_credit_finished.total.quantity,
                value:this.$store.state.user_store_report.refused_cards_credit_finished.total.amount
              }
              ],
          },
          {
            name: 'Carrinhos Abandonados',
            Contactados: this.$store.state.user_store_report.abandoned_carts.total.quantity,
            Pagos: this.$store.state.user_store_report.abandoned_carts.finished.quantity,
            Pagos_porcentagem: this.getPorcent(this.getAbandonedCart().total_pagos, this.getAbandonedCart().total_contactados) + "%",
            Total: "R$ " + this.ConvertToReal(this.getAbandonedCart().total_pagos_valor),
            TempoAbordagem: this.secondsToDhms(this.$store.state.user_store_report.abandoned_carts.total.aproach_avg_time),
            TempoConversao: this.secondsToDhms(this.$store.state.user_store_report.abandoned_carts.total.conversion_avg_time),
            detalhes:
            [
              {
                name: 'Finalizados no Boleto',
                quantity: this.$store.state.user_store_report.abandoned_carts_billet_finished.total.quantity,
                value:this.$store.state.user_store_report.abandoned_carts_billet_finished.total.amount
              },
              {
                name: 'Finalizados no Pix',
                quantity: this.$store.state.user_store_report.abandoned_carts_pix_finished.total.quantity,
                value:this.$store.state.user_store_report.abandoned_carts_pix_finished.total.amount
              },
              {
                name: 'Finalizados no Cartão',
                quantity: this.$store.state.user_store_report.abandoned_carts_card_finished.total.quantity,
                value:this.$store.state.user_store_report.abandoned_carts_card_finished.total.amount
              }
            ],
          },
          {
            name: 'Addi',
            Contactados: this.$store.state.user_store_report.addi.total.quantity,
            Pagos: this.$store.state.user_store_report.addi.finished.quantity,
            Pagos_porcentagem: this.getPorcent(this.$store.state.user_store_report.addi.finished.quantity, this.$store.state.user_store_report.addi.total.quantity) + "%",
            Total: this.$store.state.user_store_report.addi.finished.amount,
            TempoAbordagem: this.secondsToDhms(this.$store.state.user_store_report.addi.total.aproach_avg_time),
            TempoConversao: this.secondsToDhms(this.$store.state.user_store_report.addi.total.conversion_avg_time),
            detalhes:[
              {
                name: 'Finalizados no Boleto',
                quantity: this.$store.state.user_store_report.addi_billet_finished.total.quantity,
                value:this.$store.state.user_store_report.addi_billet_finished.total.amount
              },
              {
                name: 'Finalizados no Pix',
                quantity: this.$store.state.user_store_report.addi_pix_finished.total.quantity,
                value:this.$store.state.user_store_report.addi_pix_finished.total.amount
              },
              {
                name: 'Finalizados no Cartão',
                quantity: this.$store.state.user_store_report.addi_paid_credit_card.total.quantity,
                value: this.$store.state.user_store_report.addi_paid_credit_card.total.amount
              }
              ],
          },
          {
            name: 'Total',
            Contactados: this.getBillets().total_contactados + this.getPix().total_contactados + this.getRefusedCard().total_contactados + this.getAbandonedCart().total_contactados,
            Pagos: this.getBillets().total_pagos + this.getPix().total_pagos + this.getRefusedCard().total_pagos + this.getAbandonedCart().total_pagos,
            Pagos_porcentagem: this.getPorcent(
              this.getBillets().total_pagos + this.getPix().total_pagos + this.getRefusedCard().total_pagos + this.getAbandonedCart().total_pagos,
              this.getBillets().total_contactados + this.getPix().total_contactados + this.getRefusedCard().total_contactados + this.getAbandonedCart().total_contactados) + "%",
            Total: "R$ " + this.ConvertToReal(this.getBillets().total_pagos_valor + this.getPix().total_pagos_valor + this.getRefusedCard().total_pagos_valor + this.getAbandonedCart().total_pagos_valor),
            TempoAbordagem: "-",
            TempoConversao: "-",
          },
        ],
      
      }
    }
  }
</script>

<style scoped>
  table {
    border: 2px solid #3f51b5;
    border-radius: 3px;
    background-color: #fff;
  }

  th {
    color: #f9f9f9;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 1rem;
  }

  td {
    background-color: #f9f9f9;
  }

  th,
  td {
    min-width: 120px;
    padding: 10px 20px;
  }

  th.active {
    color: #fff;
  }

  th.active .arrow {
    opacity: 1;
  }
</style>